import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Slider from 'react-slick';
import useSlickCarousel from 'hooks/useSlickCarousel';
import CustomSlide from 'components/mobileBanner/CustomSlide';
import SliderBulletList from 'components/mobileBanner/SliderBulletList';
import SliderBullet from 'components/mobileBanner/SliderBullet';
import SliderBulletContainer from 'components/mobileBanner/SliderBulletContainer';
import { DesignElement, DesignCanvasLayer } from 'models/cms/booths';
import MobileBoothBanner from './SliderBanner';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const RootContainer = styled.div`
  padding: 16px 16px 0;
`;

const StyledSlider = styled(Slider)`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .slick-track {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slick-slide {
    height: 100%;
    background-color: #FFF;
  }

  & img {
    width: auto;
  }
`;

const MobileBoothBannerSlider = ({ assets }: { assets: (DesignElement | DesignCanvasLayer)[]}) => {
  const {
    activeIndex,
    sliderRef,
    postSliderChange,
    pauseSlider,
    playSlider,
  } = useSlickCarousel();

  const features = useSelector((s: any) => s.eventConfigs.features);
  const boothVideoAutoplay = useMemo(() => features.includes('boothVideoAutoplay'), [features]);
  return (
    <RootContainer>
      <StyledSlider
        autoplay={assets.length > 1}
        arrows={false}
        dots={false}
        infinite={false}
        afterChange={postSliderChange}
        pauseOnHover
        ref={sliderRef}
      >
        {assets.map((asset, index) => (
          <CustomSlide key={index}>
            <MobileBoothBanner
              asset={asset}
              onShowPopup={pauseSlider}
              onHidePopup={playSlider}
              onPlayVideo={pauseSlider}
              onPauseVideo={playSlider}
              active={index === activeIndex}
              boothVideoAutoplay={boothVideoAutoplay}
            />
          </CustomSlide>
        ))}
      </StyledSlider>
      <SliderBulletList>
        {assets.map((_, index) => (
          <SliderBulletContainer key={index}>
            <SliderBullet active={index === activeIndex} />
          </SliderBulletContainer>
        ))}
      </SliderBulletList>
    </RootContainer>
  );
};

export default MobileBoothBannerSlider;
